export default "__VITE_ASSET__186b6d23__"